import React, { useEffect, useState } from "react";
import api from "../../../../api/axios";
import { ChevronDown } from "lucide-react";

export default function OrganizationSelect({
  value = "",
  onChange,
  className = "",
  includeAll = true,
  allLabel = "All Organizations",
}) {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isOrgOpen, setIsOrgOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".organization-dropdown")) {
        setIsOrgOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    loadOrganizations();
  }, []);

  const loadOrganizations = async () => {
    try {
      setLoading(true);

      const response = await api.get("/user/list?role=organization");

      if (response?.data?.success) {
        setOrganizations(response.data.data.list || []);
      } else {
        setOrganizations([]);
      }
    } catch (err) {
      console.log(err?.response?.data?.message || err.message);
      setOrganizations([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    // <select
    //     value={value}
    //     onChange={(e) => onChange?.(e.target.value)}
    //     disabled={loading}
    //     className={`rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none ${className}`}
    // >
    //     {includeAll && <option value="">{allLabel}</option>}

    //     {organizations.map((org) => (
    //         <option key={org.org_id} value={org.org_id}>
    //             {org.org_name || org.user_name || org.email}
    //         </option>
    //     ))}
    // </select>

    <div>
      {/* <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={loading}
          className={`w-full appearance-none cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2.5 pr-10 text-sm font-medium text-slate-700 shadow-sm outline-none transition hover:border-[#ff696855] focus:border-[#ff6968] focus:ring-2 focus:ring-[#ff69681a] disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400 ${className}`}
        >
          {includeAll && <option value="">{allLabel}</option>}

          {organizations.map((org) => (
            <option key={org.org_id} value={org.org_id}>
              {org.org_name || org.user_name || org.email}
            </option>
          ))}
        </select>

        <ChevronDown
          size={17}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
        />
      </div> */}

      <div className={`organization-dropdown relative ${className}`}>
        <button
          type="button"
          disabled={loading}
          onClick={() => setIsOrgOpen((prev) => !prev)}
          className="flex w-full cursor-pointer items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-2.5 pr-3 text-sm font-medium text-slate-700 shadow-sm outline-none transition hover:border-[#ff696855] focus:border-[#ff6968] disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400"
        >
          <span className="truncate">
            {value
              ? organizations.find(
                  (org) => String(org.org_id) === String(value),
                )?.org_name ||
                organizations.find(
                  (org) => String(org.org_id) === String(value),
                )?.user_name ||
                organizations.find(
                  (org) => String(org.org_id) === String(value),
                )?.email ||
                allLabel
              : allLabel}
          </span>

          <ChevronDown
            size={17}
            className={`shrink-0 text-slate-400 transition-transform duration-200 ${
              isOrgOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {isOrgOpen && !loading && (
          <div className="absolute left-0 right-0 top-full z-50 mt-2 max-h-64 overflow-y-auto rounded-xl border border-slate-200 bg-white p-1.5 shadow-xl">
            {includeAll && (
              <button
                type="button"
                onClick={() => {
                  onChange?.("");
                  setIsOrgOpen(false);
                }}
                className={`flex w-full items-center rounded-lg px-3 py-2.5 text-left text-sm transition ${
                  value === ""
                    ? "bg-[#FFE2DE] font-semibold text-[#e95555]"
                    : "text-slate-600 hover:bg-[#FFE2DE] hover:text-[#e95555]"
                }`}
              >
                {allLabel}
              </button>
            )}

            {organizations.map((org) => {
              const label = org.org_name || org.user_name || org.email;

              const isSelected = String(value) === String(org.org_id);

              return (
                <button
                  key={org.org_id}
                  type="button"
                  onClick={() => {
                    onChange?.(org.org_id);
                    setIsOrgOpen(false);
                  }}
                  className={`mt-0.5 flex w-full items-center rounded-lg px-3 py-2.5 text-left text-sm transition ${
                    isSelected
                      ? "bg-[#FFE2DE] font-semibold text-[#e95555]"
                      : "text-slate-600 hover:bg-[#FFE2DE] hover:text-[#e95555]"
                  }`}
                >
                  {label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
